module.exports = __webpack_public_path__ + "img/icon-genshin.6f2872b.png";